import requestHandler from 'shared/utils/request-handler';
import { IGetAvatars } from './avatar.dto';

const BASE_URL = '/api/v1/Avatars';

export const GETAvatar = async () => {
	return requestHandler.call<IGetAvatars>({ url: `${BASE_URL}/me`, method: 'get' }).then(res => res.data);
};
